// extracted by mini-css-extract-plugin
export default {"__tombol__":"button___tombol____s2DQl"};